import DeviceDetector from 'device-detector-js'

function getUserAgent(req) {
  if (req) {
    return req.useragent.source
  }

  return navigator.userAgent
}

export default function (req) {
  const userAgent = getUserAgent(req)
  const deviceDetector = new DeviceDetector()
  const { device, os } = deviceDetector.parse(userAgent)

  return {
    isMobile: device?.type === 'smartphone',
    isDesktop: device?.type === 'desktop',
    isAndroid: os?.name === 'Android',
    isIOS: os?.name === 'iOS',
    isApp: userAgent.includes('TicketSwap_MobileApp'),
    isIOSApp:
      userAgent.includes('iOS') && userAgent.includes('TicketSwap_MobileApp'),
  }
}
